/** How values of a field type sit in a table or a list. */

/** Field types shown as quantities: right-aligned, so digits and decimal places line up down a column. */
const QUANTITIES: ReadonlySet<string> = new Set(["number", "money", "duration", "percentage", "quantity"]);
/** Field types whose text is mostly digits: equal-width figures keep them from shifting from row to row. */
const FIGURES: ReadonlySet<string> = new Set([
  ...QUANTITIES,
  "date",
  "time",
  "datetime",
  "local_datetime",
  "instant",
  "phone",
]);

/** How a column of values of this field type lines up. */
export const alignOf = (type: string): "right" | undefined => (QUANTITIES.has(type) ? "right" : undefined);
/** Extra classes for table cells holding values of this field type. */
export const figuresOf = (type: string): string | undefined => (FIGURES.has(type) ? "tabular-nums" : undefined);

/** A choice's display name: its label, else the option itself. */
export const optionLabel = (field: { labels?: Record<string, string> } | undefined, option: string): string =>
  field?.labels?.[option] ?? option;
